export const generateItems = (count, creator) => {
  const result = [];
  for (let i = 1; i <= count; i++) {
    result.push(creator(i));
  }
  return result;
}

export const applyDrag = (arr, dragResult) => {
  const { removedIndex, addedIndex, payload } = dragResult;
  if (removedIndex === null && addedIndex === null) return arr;

  const result = [...arr];
  let itemToAdd = payload;

  if (removedIndex !== null) {
    itemToAdd = result.splice(removedIndex, 1)[0];
  }

  if (addedIndex !== null) {
    result.splice(addedIndex, 0, itemToAdd);
  }

  return result;
};

export const formatVnd = (num) => {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + ' vnđ';
}

export const assignObjWithExistKey = (resource, destination) => {
  Object.keys(resource).forEach((key) => {
    if (destination[key] !== undefined) {
      destination[key] = resource[key];
    }
  });
}

export const formatDate = (date) => {
  if (typeof date === "string" && date) {
    const [year, month, day] = date.split('-');
    return `${day.padStart(2, 0)}-${month.padStart(2, 0)}-${year}`
  }
  return null;
}

export const parseDate = (date) => {
  if (typeof date === "string" && date) {
    const [day, month, year] = date.split('-');
    return `${year}-${month.padStart(2, 0)}-${day.padStart(2, 0)}`
  }
  return null;
}

export const debounce = (fn, delay) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn(...args);
    }, delay);
  };
};

export const randomNumber = (length) => {
  return Math.floor(Math.random() * length)
}
